import React from "react";

class ShowReport extends React.Component {
    render() {
        return (
            <div style={{ textAlign: 'center', padding: '12px 0 32px' }}>
                {/* Success icon */}
                <div style={{
                    width: '76px', height: '76px', borderRadius: '50%',
                    background: 'rgba(0,190,90,0.1)',
                    border: '2px solid rgba(0,190,90,0.3)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 22px',
                    boxShadow: '0 0 40px rgba(0,190,90,0.12)',
                }}>
                    <span style={{ color: '#00be5a', fontSize: '30px', lineHeight: 1 }}>✓</span>
                </div>

                <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#00be5a', fontWeight: '800', marginBottom: '12px' }}>
                    BOOKING CONFIRMED
                </div>
                <h2 style={{ color: 'white', fontSize: 'clamp(18px, 3vw, 26px)', fontWeight: '900', margin: '0 0 8px' }}>
                    {this.props.REPAIR_TYPE?.value} {this.props.REPAIR_DEVICE?.value} Repair
                </h2>
                <p style={{ color: '#555', fontSize: '13px', margin: '0 0 32px', lineHeight: '1.6' }}>
                    Your repair request has been submitted successfully.
                </p>

                {/* Info cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '12px', maxWidth: '580px', margin: '0 auto 28px' }}>
                    {[
                        { label: 'Customer', value: `${this.props.PR_FIRST_NAME} ${this.props.PR_LAST_NAME}` },
                        { label: 'Email', value: this.props.PR_EMAIL },
                        { label: 'Date', value: this.props.REPAIR_DATE || '—' },
                        { label: 'Time', value: this.props.REPAIR_TIME || '—' },
                    ].map(item => (
                        <div key={item.label} style={{
                            background: 'rgba(255,255,255,0.03)',
                            border: '1px solid rgba(255,255,255,0.07)',
                            borderRadius: '12px', padding: '16px 14px',
                        }}>
                            <div style={{ color: '#444', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '7px' }}>
                                {item.label}
                            </div>
                            <div style={{ color: 'white', fontSize: '13px', fontWeight: '700', wordBreak: 'break-word' }}>
                                {item.value}
                            </div>
                        </div>
                    ))}
                </div>

                <p style={{ color: '#3a3a3a', fontSize: '12px', margin: 0, lineHeight: '1.7' }}>
                    The shopkeeper will contact you shortly to confirm your appointment.
                </p>
            </div>
        );
    }
}

export default ShowReport;
